module.exports = __webpack_public_path__ + "static/media/homemalo.474cd382.png";


//////////////////
// WEBPACK FOOTER
// ./src/homemalo.png
// module id = 231
// module chunks = 0